module.exports = __webpack_public_path__ + "img/icon_management01.bb4aa370.svg";